import Filter from '../src/Filter';
export default Filter;
